<template>
  <mu-dialog :open="showOver" dialogClass="game-over-dialog">
    <div slot='title'
      style="
        width: 100%;
        display: flex;
        justify-content: center;
      ">
      <h3 style = "
        margin: 0px;
      ">完成了   {{score.name}}</h3>
    </div>
    <mu-row class="center-style" gutter>
      <div>本局得分</div>
    </mu-row>
    <mu-row class="center-style" gutter>
      <mu-col>
        <div class="scoreLine">
         <div class="left-wrap"><span class="lines lines-left"></span><span class="diamond diamond-left"></span></div>
         <span v-if="gameFlag==1 && score.score >=0" class="text">{{score.score}}</span>
         <span v-else-if="gameFlag==1" class="text">{{score.transcript.score}}</span>
         <span v-else class="text">{{score.todayPoints}}</span>
         <div class="right-wrap"><span class="diamond diamond-right"></span><span class="lines lines-right"></span></div>
        </div>
        <!--
        <div class = "game-score-desc">
        上次得分
          <span >{{score.lastScore}}</span>&nbsp;分
        </div>
        -->
      </mu-col>
    </mu-row>
    <mu-row class="center-style" gutter>
      <mu-col v-if="tempFlag != 1">
     
        <div v-if="gameFlag == 1" class="last-desc">上次得分
          <span class="last-score">{{score.lastScore}}</span>&nbsp;分
        </div>
         <!--
         <div v-if="gameFlag == 1" class="last-desc">游戏时长
          <span class="last-score">{{trainsTime}}</span>&nbsp;秒
        </div> -->
      </mu-col>
      <mu-col v-if="gameFlag != 1">
        <div class="center-style">
          <span v-if="tempFlag !=1">
            <span v-if="score.yesterdayPoints == 0">上次得分&nbsp;<b class="blackfontscore">-</b>&nbsp;分</span>
            <span v-else>上次得分&nbsp;<b class="blackfontscore">{{score.yesterdayPoints}}</b>&nbsp;分</span>
          </span>
          <!-- <span v-if="score.avgTime == ''" style="margin-left:30px;">正确作答平均反应时间&nbsp; <b class="blackfontscore">"—"</b></span>
          <span v-else style="margin-left:30px;">正确作答平均反应时间&nbsp; <b class="blackfontscore">{{score.avgTime}}</b></span> -->
        </div>
       
        <div class="last-desc">
          <span>正确题数/总题数&nbsp;<b class="blackfontscore">{{score.rightNumber}}/{{score.totalNumber}}</b>&nbsp;</span>
          <span style="margin-left:30px;">正确率&nbsp;<b class="blackfontscore">{{score.rightDate}}</b></span>
        </div>
      </mu-col>
    </mu-row>
    <mu-row class="center-style" gutter>
      <mu-col>
        <div class="all-desc" v-if="showAll">
          <div>恭喜！您已完成今日所有训练任务！</div>
          <div>明天继续加油~</div>
        </div>
      </mu-col>
    </mu-row>
     <div class='interationl' style="margin-bottom: 20px;" v-if="game.id>200">
             <h4 style="">专业解读:</h4>
             <p> {{game.pro_interpretation}}   
              <span style='color:#0a81e5' class='reference-id' @click='ReferenceConfirm'><sup>{{showRefer}}</sup></span></p>
    </div>
    <div class='pro-Inter' v-if='showPro'>
          <div style='display:flex;height:30px'>
          <h5 style='display:flex;justify-content:center;background-color:rgb(209,209,209);margin-top:0px;height:20px;width:100%'>参考文献</h5>
          <div class="closeX" style="border-style:none;" @click='ReferenceConfirm'><img style='background-color:rgb(209,209,209);' src="../../assets/img/icon_close.png" /></div>
          </div>
          <p style='font-size:14px; word-wrap:break-word;word-break:break-all;margin-left: 4px;margin-right: 4px;' v-for='(value,key,index) in ReferObj'>
             {{key}}{{value}}
          </p>
    </div>
    <mu-raised-button label="返回" style="color:#444;margin-left:60px;border-radius:0px;left: 50%;" class="btn-style" @click="return2Today" />
    <mu-raised-button label="再练一次" :disabled="forbid" style='border-radius:0px; left:55%;' class="btn-style" @click="restart" primary />
    <mu-raised-button label="下一个训练" :disabled="forbid" style="margin-left:20px;border-radius:0px;right:10%" @click="nextGame" class="btn-style" v-if="showNextButton" primary />
  </mu-dialog>
</template>

<script>
import {getSelect} from '../../assets/js/common.js'
import {mapState,mapMutations} from 'vuex'
export default {
  // gameFlag：1为认知，2为言语;
  // tempFlag:1为临时训练，undefined为正式训练
  // forbid: false为可以再次训练；true为不可以再次训练
  props:["score", "gameFlag", "tempFlag", "forbid", "showNextButton", "gameData"],
  data () {
    return {
      showAll: false,
      showOver: true,
      trainTime:"",//训练的实际时间
      showPro:false,
      showRefer:'',
      ReferList:[],
      game:'',
      countReferList:[],//参考文献的小标题
      ReferObj:{},//参考文献每个小标题对应的文献
    }
  },
  mounted(){
    console.log(this.gameData);
    console.log("++++++++++++++++++++++++++")
    console.log(this.score)
    console.log("++++++++++++++++++++++++++")
     console.log(this.$parent);
     if(this.$parent.hasOwnProperty('game')){
       this.game=this.$parent.game;
     }
    if(this.$parent.hasOwnProperty('gameData')){
       this.game=this.$parent.gameData;
      }
    this.countReferList=this.getBracketStr();
    this.showRefer=this.getBracketStr().join('');
    var refgex=/\[[0-9]\]/g;
    this.ReferList=this.game.refer_document.split(refgex);
    this.ReferList=this.ReferList.slice(1,this.ReferList.length)
    //console.log(this.countReferList)
    //console.log(this.ReferList)
    this.ReferObj=this.setReferObj();
  },
  computed: {

    sex: function() {
      return getSelect('gender', this.info.gender)
    },
    ...mapState(["trainsTime"])
  },
  methods: {
    return2Today: function () {
      this.$emit("close");
      this.showOver = false;
    },
    restart: function(){
      this.$emit("restart",1); //传出一个flag用来记录再练一次的等级
    },
    nextGame(){
      this.$emit("next",this.gameData);
    },
    ReferenceConfirm(){
    this.showPro=!this.showPro;
    },
    //查找小标题
    getBracketStr(){
      var str=this.game.refer_document;
     console.log(typeof(str))
      var r=/\[(.+?)\]/g;
      return str.match(r);
      
    },
    //设置小标题对应的文献
    setReferObj(){
      var Obj=new Object();
      for(let i=0;i<this.countReferList.length;i++){
        Obj[this.countReferList[i]]=this.ReferList[i];
      }
      return Obj;
    },
  }
}
</script>
<style lang='styl' scoped>
  @import "../../assets/css/app.styl";
.center-style{
  display: flex;
  justify-content: center;
  text-align: center;
}
.pro-Inter{
    position:fixed;
    left:25%;
    top:50%;
    right:0;
    z-index:999;
    width:50%;
    background-color:white;
    border:solid 1px;
}
.scoreLine{
  height:128px;
  line-height:128px;
  text-align:center;
  font-size:112px;
  color:#0a81e5;
  position:relative;
}
.left-wrap,.right-wrap{
  position: relative;
  display: inline-block;
  width:160px;
  height: 40px;
}
.text{
  display: inline-block;
}
.scoreLine .lines{
  position:absolute;
  width: 150px;
  height: 32px;
  border-top: 1px solid #0a81e5 ;
}
.lines-left{
    top: 0;
    left: 0;
}
.lines-right{
    top: 0;
    right: 0;
}
.diamond{
  display:inline-block;
  background-color: #0A81E5;
  width:14px;
  height:14px;
  transform:rotate(-45deg);
  line-height:123px;
  position:absolute;
  top:-6px;
}
.diamond-left{
  left:134px;
}
.diamond-right{
  right:134px;
}
.game-score-desc {
  font-size:18px;
  color:#999;
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
.last-desc {
  margin:20px 20px 60px 20px
  display: inline-block;
}
.last-score {
  font-size:32px;
  color:#888;
  vertical-align:middle;
  font-family: 'trebuchet ms', verdana, arial
}
.all-desc {
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
}
.blackfontscore{
  color:black!important;
}
</style>
<style>
.game-over-dialog{
  width:768px !important;
  max-width:768px !important;
}
.reference-id:hover{
  cursor:pointer;
}

</style>




// WEBPACK FOOTER //
// gameOver.vue?ebc9a04c